import { render, staticRenderFns } from "./InputComprehensiveEvaluation.vue?vue&type=template&id=08e721cc&scoped=true&"
import script from "./InputComprehensiveEvaluation.vue?vue&type=script&lang=js&"
export * from "./InputComprehensiveEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./InputComprehensiveEvaluation.vue?vue&type=style&index=0&id=08e721cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e721cc",
  null
  
)

export default component.exports